module.exports = __webpack_public_path__ + "img/105.9.1d0e1562.png";